import React from 'react'
import img from "../../assets/img/Group2.png";
import "./HomeImage.css"

function HomeImage() {
  return (
    <div className='homeimg' >
        <img  className = "homeimg_content" src={img} alt="man"/>    
    </div>
  )
}

export default HomeImage